export default "__VITE_ASSET__0q9hOjT2__"